<template>
  <div>
    <table v-if="list.deviceStatusList[3] && list.deviceIsconnected == 3">
      <tr>
        <th>{{ $t("lang.particulars.IP") }}</th>
        <td v-if="list.deviceStatusList[3].dsIp">
          {{ list.deviceStatusList[3].dsIp }}
        </td>
        <td v-else>N/A</td>
        <th>{{ $t("lang.particulars.gateway") }}</th>
        <td v-if="list.deviceStatusList[3].dsGateway">
          {{ list.deviceStatusList[3].dsGateway }}
        </td>
        <td v-else>N/A</td>
      </tr>
      <tr v-if="list.deviceStatusList[3].dsIpv6">
        <th>{{ $t("lang.particulars.wan3g1IPV6") }}</th>
        <td>
          <span style="white-space: pre">{{
            list.deviceStatusList[3].dsIpv6 | ipv6
          }}</span>
        </td>
      </tr>
      <tr>
        <th>{{ $t("lang.particulars.NonContiguousSubnetMask") }}</th>
        <td v-if="list.deviceStatusList[3].dsNetmask">
          {{ list.deviceStatusList[3].dsNetmask }}
        </td>
        <td v-else>N/A</td>
        <th>{{ $t("lang.particulars.NETWORK") }}</th>
        <td
          v-if="
            list.deviceStatusList[3] && list.deviceStatusList[3].dsProto == 0
          "
        >
          PPP
        </td>
        <td
          v-else-if="
            list.deviceStatusList[3] && list.deviceStatusList[3].dsProto == 1
          "
        >
          DHCP
        </td>
        <td
          v-else-if="
            list.deviceStatusList[3] && list.deviceStatusList[3].dsProto == 2
          "
        >
          {{ $t("lang.particulars.addressStrings") }}
        </td>
        <td v-else>N/A</td>
      </tr>
      <tr v-if="list.deviceStatusList[3]">
        <th>{{ $t("lang.particulars.DNS1") }}</th>
        <td v-if=" list.deviceStatusList[3].dsDns && list.deviceStatusList[3].dsDns.split(',')[0]">
          {{ list.deviceStatusList[3].dsDns.split(",")[0] }}
        </td>
        <td v-else>N/A</td>
        <th>{{ $t("lang.particulars.DNS2") }}</th>
        <td v-if="list.deviceStatusList[3].dsDns && list.deviceStatusList[3].dsDns.split(',')[1]">
          {{ list.deviceStatusList[3].dsDns.split(",")[1] }}
        </td>
        <td v-else>N/A</td>
      </tr>
      <tr>
        <th>{{ $t("lang.particulars.NETWORK_FAUX_QUEUE") }}</th>
        <td v-if="list.deviceNetStatusList[0]">
          {{ SecondToDate(list.deviceNetStatusList[0].tfDuration) }}
        </td>
        <td v-else>N/A</td>
        <th>{{ $t("lang.particulars.Connection") }}</th>
        <td v-if="list.deviceStatusList[3].dsIp">
          {{ $t("lang.particulars.connected") }}
        </td>
        <td v-else>{{ $t("lang.particulars.disOpened") }}</td>
      </tr>
      <tr>
        <th>{{ $t("lang.particulars.UpdateTime") }}</th>
        <td>{{ list.deviceStatusList[3].dsUpdate }}</td>
      </tr>
    </table>

    <table v-else>
      <tr>
        <th>{{ $t("lang.particulars.IP") }}</th>
        <td>{{ $t("lang.particulars.unknown") }}</td>
        <th>{{ $t("lang.particulars.gateway") }}</th>
        <td>{{ $t("lang.particulars.unknown") }}</td>
      </tr>
      <tr>
        <th>{{ $t("lang.particulars.NonContiguousSubnetMask") }}</th>
        <td>{{ $t("lang.particulars.unknown") }}</td>
        <th>{{ $t("lang.particulars.NETWORK") }}</th>
        <td>{{ $t("lang.particulars.unknown") }}</td>
      </tr>
      <tr>
        <th>{{ $t("lang.particulars.DNS1") }}</th>
        <td>{{ $t("lang.particulars.unknown") }}</td>
        <th>{{ $t("lang.particulars.DNS2") }}</th>
        <td>{{ $t("lang.particulars.unknown") }}</td>
      </tr>
      <tr>
        <th>{{ $t("lang.particulars.NETWORK_FAUX_QUEUE") }}</th>
        <td>{{ $t("lang.particulars.unknown") }}</td>
        <th>{{ $t("lang.particulars.Connection") }}</th>
        <td>{{ $t("lang.particulars.unknown") }}</td>
      </tr>
      <tr>
        <th>{{ $t("lang.particulars.UpdateTime") }}</th>
        <td>{{ $t("lang.particulars.unknown") }}</td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: ["list"],
  data() {
    return {};
  },
  methods: {
    //计算秒数
    SecondToDate(msd) {
      var time = msd;
      if (null != time && "" != time) {
        if (time > 60 && time < 60 * 60) {
          time =
            parseInt(time / 60.0) +
            this.$t("lang.particulars.minutes") +
            parseInt((parseFloat(time / 60.0) - parseInt(time / 60.0)) * 60) +
            this.$t("lang.particulars.seconds");
        } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
          time =
            parseInt(time / 3600.0) +
            this.$t("lang.particulars.hours") +
            parseInt(
              (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
            ) +
            this.$t("lang.particulars.minutes") +
            parseInt(
              (parseFloat(
                (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
              ) -
                parseInt(
                  (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
                )) *
                60
            ) +
            this.$t("lang.particulars.seconds");
        } else if (time >= 60 * 60 * 24) {
          time =
            parseInt(time / 3600.0 / 24) +
            this.$t("lang.particulars.Day") +
            parseInt(
              (parseFloat(time / 3600.0 / 24) - parseInt(time / 3600.0 / 24)) *
                24
            ) +
            this.$t("lang.particulars.hours") +
            parseInt(
              (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
            ) +
            this.$t("lang.particulars.minutes") +
            parseInt(
              (parseFloat(
                (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
              ) -
                parseInt(
                  (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
                )) *
                60
            ) +
            this.$t("lang.particulars.seconds");
        } else {
          time = parseInt(time) + this.$t("lang.particulars.seconds");
        }
      }
      return time;
    },
  },
  filters: {
    ipv6(e) {
      let a = e.split("#");
      console.log(a);
      let html = ``;
      a.forEach((v) => {
        html += `${v}\n`;
      });
      return html;
    },
  },
};
</script>
<style scoped src="./particulars.css"></style>
